import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login';
// import Index from '@/views/index';//首页
// import Analysis from "@/views/f1_dashboard/p1_analysis";//分析页
import store from '@/vuex/index';


//解决报错：e-router.esm.js:2046 Uncaught (in promise) Error: Redirected when going from
const originalPush = Router.prototype.push
Router.prototype.push = function (location, onComplete, onAbort) {
    if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
        return originalPush.call(this, location, onComplete, onAbort).catch(err => { })
    } else {
        // <router-link>进行路由跳转时，传了一个oncomplate方法
        originalPush.call(this, location, onComplete, onAbort)
    }
}



Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: '',
        component: Login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: 'Login',
        component: Login,
        hidden: true,
        meta: {
            requireAuth: false,
            title: "登录"
        }
    },
    {
        path: "/404",
        name: "NotFind",
        component: () => import("@/views/notFind.vue"),
        meta: {
            requireAuth: false,
            title: "404"
        }

    }
        // {
        //     path: '/dashboard',
        //     name: 'Index',
        //     component: Index,
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/dashboard/analysis",
        //     meta: {
        //         title: "首页"
        //     },
        //     children: [
        //         {
        //             path: '/dashboard/analysis',
        //             name: 'Dashboard_Analysis',
        //             component: Analysis,
        //             meta: {
        //                 title: "分析页",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/dashboard/workbench',
        //             name: 'Dashboard_Workbench',
        //             component: () => import("@/views/f1_dashboard/p2_workbench"),
        //             meta: {
        //                 title: "工作台",
        //                 requireAuth: true
        //             }
        //         }
        //     ]
        // },
        // {
        //     path: '/sys',
        //     name: 'Sys',
        //     component: Index,
        //     iconCls: 'el-icon-tickets',
        //     meta: {
        //         title: "系统管理"
        //     },
        //     children: [
        //         {
        //             path: '/sys/menu',
        //             name: 'Sys_Menu',
        //             component: () => import("@/views/f2_system/p1_menu"),
        //             meta: {
        //                 title: "菜单管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/user',
        //             name: 'Sys_User',
        //             component: () => import("@/views/f2_system/p2_user"),
        //             meta: {
        //                 title: "用户管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/dept',
        //             name: 'Sys_Dept',
        //             component: () => import("@/views/f2_system/p3_dept"),
        //             meta: {
        //                 title: "部门管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/role',
        //             name: 'Sys_Role',
        //             component: () => import("@/views/f2_system/p4_role"),
        //             meta: {
        //                 title: "角色管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/tenant',
        //             name: 'Sys_Unit',
        //             component: () => import("@/views/f2_system/p5_unit"),
        //             meta: {
        //                 title: "单位管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/log',
        //             name: 'Sys_Log',
        //             component: () => import("@/views/f2_system/p6_log"),
        //             meta: {
        //                 title: "操作日志",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/gen',
        //             name: 'Sys_Code',
        //             component: () => import("@/views/f2_system/p7_code"),
        //             meta: {
        //                 title: "代码生成",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/message',
        //             name: 'Sys_Message',
        //             component: () => import("@/views/f2_system/p8_message"),
        //             meta: {
        //                 title: "消息管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/sys/config',
        //             name: 'Sys_Config',
        //             component: () => import("@/views/f2_system/p9_config"),
        //             meta: {
        //                 title: "系统设置",
        //                 requireAuth: true
        //             }
        //         },
        //     ]
        // },
        // {
        //     path: '/exam',
        //     name: 'Exam',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/exam/course",
        //     component: Index,
        //     meta: {
        //         title: "考务管理"
        //     },
        //     children: [
        //         {
        //             path: '/exam/course',
        //             name: 'Exam_Course',
        //             component: () => import("@/views/f3_exam/p1_course"),
        //             meta: {
        //                 title: "课程管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/examination',
        //             name: 'Exam_Examination',
        //             component: () => import("@/views/f3_exam/p2_examination"),
        //             meta: {
        //                 title: "考试管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/examination_subjects/:id',
        //             name: 'Exam_Examination_subjects',
        //             component: () => import("@/views/f3_exam/p3_subItem"),
        //             meta: {
        //                 title: "题目管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/subject',
        //             name: 'Exam_Subject',
        //             component: () => import("@/views/f3_exam/p4_subject"),
        //             meta: {
        //                 title: "题库管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/score',
        //             name: 'Exam_Score',
        //             component: () => import("@/views/f3_exam/p5_score"),
        //             meta: {
        //                 title: "成绩管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/score_detail/:id',
        //             name: 'Exam_ScoreDetail',
        //             component: () => import("@/views/f3_exam/p6_scoreDetail"),
        //             meta: {
        //                 title: "成绩详情",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/subject_detail/:id',
        //             name: 'Exam_SubjectDetail',
        //             component: () => import("@/views/f3_exam/p7_subjectDetail"),
        //             meta: {
        //                 title: "题目详情",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/exam/course_chapter/:id',
        //             name: 'Exam_Course_chapter',
        //             component: () => import("@/views/f3_exam/p8_courseChapter"),
        //             meta: {
        //                 title: "课程章节",
        //                 requireAuth: true
        //             }
        //         },
        //     ]
        // },
        // {
        //     path: '/attachment',
        //     name: 'Attachment',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/attachment/course",
        //     component: Index,
        //     meta: {
        //         title: "附件管理"
        //     },
        //     children: [
        //         {
        //             path: '/attachment/list',
        //             name: 'Attachment_List',
        //             component: () => import("@/views/f4_attachment/p1_list"),
        //             meta: {
        //                 title: "附件列表",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: '/attachment/group',
        //             name: 'Attachment_Group',
        //             component: () => import("@/views/f4_attachment/p2_group"),
        //             meta: {
        //                 title: "附件分组",
        //                 requireAuth: true
        //             }
        //         },
        //     ]
        // },
        // {
        //     path: '/speech',
        //     name: 'Speech',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/speech/course",
        //     component: Index,
        //     meta: {
        //         title: "语音合成"
        //     },
        //     children: [
        //         {
        //             path: '/speech/synthesis',
        //             name: 'speech_Synthesis',
        //             component: () => import("@/views/f5_speech/p1_synthesis"),
        //             meta: {
        //                 title: "语音管理",
        //                 requireAuth: true
        //             }
        //         },]
        // },
        // {
        //     path: '/operation',
        //     name: 'Operation',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/operation/course",
        //     component: Index,
        //     meta: {
        //         title: "运营管理"
        //     },
        //     children: [
        //         {
        //             path: '/operation/banner',
        //             name: 'Operation_Banner',
        //             component: () => import("@/views/f6_operation/p1_banner"),
        //             meta: {
        //                 title: "Banner管理",
        //                 requireAuth: true
        //             }
        //         },]
        // },
        // {
        //     path: '/personal',
        //     name: 'Personal',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/personal/course",
        //     component: Index,
        //     meta: {
        //         title: "个人中心"
        //     },
        //     children: [
        //         {
        //             path: '/personal/details',
        //             name: 'Personal_Details',
        //             component: () => import("@/views/f7_personal/p1_details"),
        //             meta: {
        //                 title: "个人资料",
        //                 requireAuth: true
        //             }
        //         }, {
        //             path: '/personal/password',
        //             name: 'personal_Password',
        //             component: () => import("@/views/f7_personal/p2_password"),
        //             meta: {
        //                 title: "修改密码",
        //                 requireAuth: true
        //             }
        //         },]
        // }, 
        // {
        //     path: '/eight',
        //     name: 'Eight',
        //     iconCls: 'el-icon-tickets',
        //     // redirect: "/personal/course",
        //     component: Index,
        //     meta: {
        //         title: "八大员"
        //     },
        //     children: [
        //         {
        //             path: "/eight/courseClass",
        //             name: "CourseClass",
        //             component: () => import("@/views/f8_manager/p1_courseClass.vue"),
        //             meta: {
        //                 title: "课程分类",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/discipline",
        //             name: "Discipline",
        //             component: () => import("@/views/f8_manager/p2_discipline.vue"),
        //             meta: {
        //                 title: "学科专业",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/teacherManagement",
        //             name: "TeacherManagement",
        //             component: () => import("@/views/f8_manager/p3_teacherManagement.vue"),
        //             meta: {
        //                 title: "教师管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/courseManagement",
        //             name: "CourseManagement",
        //             component: () => import("@/views/f8_manager/p4_courseManagement.vue"),
        //             meta: {
        //                 title: "课程管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/classManagement",
        //             name: "ClassManagement",
        //             component: () => import("@/views/f8_manager/p5_classManagement.vue"),
        //             meta: {
        //                 title: "班级管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/studentManagement",
        //             name: "StudentManagement",
        //             component: () => import("@/views/f8_manager/p6_studentManagement.vue"),
        //             meta: {
        //                 title: "学生管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/classStudentManagement",
        //             name: "ClassStudentManagement",
        //             component: () => import("@/views/f8_manager/p7_classStudentManagement.vue"),
        //             meta: {
        //                 title: "班级学生管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/course",
        //             name: "Course",
        //             component: () => import("@/views/f8_manager/p8_course.vue"),
        //             meta: {
        //                 title: "推荐课程管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/friendLink",
        //             name: "FriendLink",
        //             component: () => import("@/views/f8_manager/p9_friendLink.vue"),
        //             meta: {
        //                 title: "友情链接管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/system_nav",
        //             name: "System_nav",
        //             component: () => import("@/views/f8_manager/p10_system_nav.vue"),
        //             meta: {
        //                 title: "系统导航管理",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/categoryList",
        //             name: "CategoryList",
        //             component: () => import("@/views/f8_manager/p11_categoryList.vue"),
        //             meta: {
        //                 title: "文章发布",
        //                 requireAuth: true
        //             }
        //         },
        //         {
        //             path: "/eight/system_message",
        //             name: "System_message",
        //             component: () => import("@/views/f8_manager/p12_system_message.vue"),
        //             meta: {
        //                 title: "系统消息",
        //                 requireAuth: true
        //             }
        //         },


        //     ]
        // }
    ]
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js